// extracted by css-extract-rspack-plugin
export default {"picker":"K0TzHWBxoKAUdTjB","legend":"DLKdQAm6Z0rPPn3L","option":"utTcQQNNEZAkaa78","optionSecondary":"K9X4WJAZdL0hTAr8"};